const en = {
  nav: { destinations: "Destinations", services: "Services", guide: "Alpha Guide", app: "The App", trust: "Trust", cta: "Start Your Journey" },
  cont: { europe: "Europe", "north-america": "North America", "middle-east": "Middle East", asia: "Asia", oceania: "Oceania", islands: "Premium Islands" },
  hero: {
    eyebrow: "A premium global travel platform",
    title1: "Discover the World",
    title2: "with Confidence.",
    sub: "Hotels, private transfers, local Alpha Guides and concierge-level care — one platform, every continent, zero friction.",
    cta: "Start Your Journey",
    search: "Search a country, city or airport…",
    statCountries: "Countries", statCities: "Cities", statSupport: "Alpha Guide support", statLangs: "Languages",
  },
  search: { noResults: "No matches — try Paris, Dubai, CDG…", country: "Country", city: "City", airport: "Airport" },
  atlas: { eyebrow: "01 — The Atlas", title: "One platform. Every horizon.", sub: "Choose a continent, tap a country, and watch the world rearrange itself around your journey.", soon: "Opening soon", explore: "Explore" },
  services: { eyebrow: "02 — Services", title: "Everything, arranged.", sub: "Nine signature services, one standard: flawless." },
  svc: {
    hotels: { t: "Hotels", d: "Hand-picked stays, from boutique icons to palace suites." },
    transfers: { t: "Airport Transfers", d: "Seamless arrivals — your driver waits before you land." },
    vip: { t: "VIP Transfers", d: "Discreet, armored-on-request, red-carpet mobility." },
    chauffeur: { t: "Private Chauffeurs", d: "A professional at the wheel, by the hour or the week." },
    guides: { t: "Local Guides", d: "Licensed locals who open doors no app can." },
    tours: { t: "Private Tours", d: "Itineraries built around you, never the crowd." },
    family: { t: "Family Travel", d: "Kid-ready logistics, from car seats to connecting rooms." },
    business: { t: "Luxury & Business", d: "Boardroom-to-beach travel, expensed without friction." },
    medical: { t: "Medical Travel Support", d: "Clinics, translators and care — coordinated end to end." },
  },
  guide: {
    eyebrow: "03 — Alpha Guide",
    title: "A human, wherever you land.",
    p1: "Every Aurevia journey includes an Alpha Guide — a vetted local professional on call for your entire stay.",
    p2: "Missed connection, lost reservation, 3 a.m. pharmacy run — one message and it is handled.",
    b1: { t: "Local & vetted", d: "Background-checked professionals in every city we serve." },
    b2: { t: "24/7 on-trip assistance", d: "Real humans, your language, any hour." },
    b3: { t: "Proactive care", d: "Flight delays, weather, closures — we reroute before you notice." },
    cta: "Travel with an Alpha Guide",
  },
  app: {
    eyebrow: "04 — The App",
    title: "Your journey, in your pocket.",
    sub: "Live itinerary, driver tracking, Alpha Guide chat and one-tap rebooking — on iPhone and Android.",
    ios: "Download on the App Store",
    android: "Get it on Google Play",
    soon: "Screenshots — arriving with the beta",
    placeholder: "Screenshot placeholder",
  },
  trust: {
    eyebrow: "05 — Trust & Security",
    title: "Built to be trusted.",
    sub: "The invisible machinery behind an effortless journey.",
    payments: { t: "Secure payments", d: "PCI-DSS compliant processing with 3-D Secure on every transaction." },
    verified: { t: "Verified providers", d: "Every hotel, driver and guide passes a 27-point audit." },
    privacy: { t: "Privacy first", d: "Your itinerary is yours. GDPR-aligned, never sold." },
    performance: { t: "Performance", d: "99.95% platform uptime, monitored around the clock." },
  },
  form: {
    eyebrow: "Concierge", title: "Start your journey.",
    sub: "Tell us where you're headed. A travel designer replies within one business day.",
    name: "Full name", email: "Email", destination: "Destination", anywhere: "Anywhere / not sure yet",
    message: "Tell us about your trip", submit: "Send inquiry", sending: "Sending…",
    success: "Received — your travel designer will be in touch shortly.", error: "Something went wrong. Please try again.",
  },
  footer: { tagline: "Discover the World with Confidence.", contact: "Contact", privacy: "Privacy & UK GDPR", rights: "© 2026 Aurevia Travella. All rights reserved.", langNote: "Available in 5 languages — more on the way." },
  country: {
    overview: "Overview", cities: "Cities", services: "Available services",
    cta: "Plan my trip — {country}",
    intro: "From iconic capitals to quiet coastlines, {country} rewards those who arrive curious. Aurevia arranges every mile — hotels, transfers, guides — under one roof.",
    back: "All destinations", citiesCount: "{count} cities",
  },
  city: {
    whyTitle: "Why go",
    highlights: "Highlights", experiences: "Recommended experiences", services: "Available services",
    guideTitle: "Your Alpha Guide in {city}",
    guideText: "Airport pickup to last-minute tables — your Alpha Guide knows {city} like only a local can.",
    gallery: "Gallery", cta: "Plan my {city} journey",
    intro: "{city} rewards the curious. With Aurevia, the icons and hidden corners of {country} come with a driver, a guide and a plan that bends around you.",
    h1: "Iconic landmarks, after-hours access", h2: "Neighbourhoods only locals know", h3: "Day trips, handled door to door",
    e1: "Private sunrise tour of the old town", e2: "Chef-led market walk & tasting", e3: "Skip-the-line museum afternoon",
  },
};

const tr = {
  nav: { destinations: "Destinasyonlar", services: "Hizmetler", guide: "Alpha Guide", app: "Uygulama", trust: "Güven", cta: "Yolculuğuna Başla" },
  cont: { europe: "Avrupa", "north-america": "Kuzey Amerika", "middle-east": "Orta Doğu", asia: "Asya", oceania: "Okyanusya", islands: "Premium Adalar" },
  hero: {
    eyebrow: "Premium küresel seyahat platformu",
    title1: "Dünyayı Keşfet",
    title2: "Güvenle.",
    sub: "Oteller, özel transferler, yerel Alpha Guide'lar ve konsiyerj düzeyinde özen — tek platform, her kıta, sıfır zahmet.",
    cta: "Yolculuğuna Başla",
    search: "Ülke, şehir veya havalimanı ara…",
    statCountries: "Ülke", statCities: "Şehir", statSupport: "Alpha Guide desteği", statLangs: "Dil",
  },
  search: { noResults: "Sonuç yok — Paris, Dubai, CDG deneyin…", country: "Ülke", city: "Şehir", airport: "Havalimanı" },
  atlas: { eyebrow: "01 — Atlas", title: "Tek platform. Her ufuk.", sub: "Bir kıta seçin, bir ülkeye dokunun ve dünyanın yolculuğunuza göre yeniden şekillenmesini izleyin.", soon: "Yakında", explore: "Keşfet" },
  services: { eyebrow: "02 — Hizmetler", title: "Her şey, sizin için ayarlandı.", sub: "Dokuz imza hizmet, tek standart: kusursuzluk." },
  svc: {
    hotels: { t: "Oteller", d: "Butik ikonlardan saray süitlerine özenle seçilmiş konaklamalar." },
    transfers: { t: "Havalimanı Transferleri", d: "Sorunsuz varış — sürücünüz siz inmeden hazır." },
    vip: { t: "VIP Transferler", d: "Gizli, isteğe bağlı zırhlı, kırmızı halı konforunda ulaşım." },
    chauffeur: { t: "Özel Şoförler", d: "Direksiyonda bir profesyonel; saatlik ya da haftalık." },
    guides: { t: "Yerel Rehberler", d: "Hiçbir uygulamanın açamayacağı kapıları açan lisanslı yereller." },
    tours: { t: "Özel Turlar", d: "Kalabalığa göre değil, size göre kurgulanan rotalar." },
    family: { t: "Aile Seyahati", d: "Çocuk koltuğundan birleşen odalara, aileye hazır lojistik." },
    business: { t: "Lüks & İş Seyahati", d: "Toplantı salonundan plaja, zahmetsiz seyahat." },
    medical: { t: "Tıbbi Seyahat Desteği", d: "Klinikler, tercümanlar ve bakım — uçtan uca koordinasyon." },
  },
  guide: {
    eyebrow: "03 — Alpha Guide",
    title: "İndiğiniz her yerde bir insan.",
    p1: "Her Aurevia yolculuğu bir Alpha Guide içerir — konaklamanız boyunca size özel, doğrulanmış yerel bir profesyonel.",
    p2: "Kaçan bağlantı, kaybolan rezervasyon, gece üçte eczane — tek mesaj, çözülür.",
    b1: { t: "Yerel ve doğrulanmış", d: "Hizmet verdiğimiz her şehirde geçmişi denetlenmiş profesyoneller." },
    b2: { t: "7/24 yolculuk desteği", d: "Gerçek insanlar, sizin dilinizde, her saat." },
    b3: { t: "Proaktif özen", d: "Rötar, hava durumu, kapanışlar — siz fark etmeden rotayı değiştiririz." },
    cta: "Alpha Guide ile seyahat edin",
  },
  app: {
    eyebrow: "04 — Uygulama",
    title: "Yolculuğunuz cebinizde.",
    sub: "Canlı seyahat programı, sürücü takibi, Alpha Guide sohbeti ve tek dokunuşla yeniden rezervasyon — iPhone ve Android'de.",
    ios: "App Store'dan indirin",
    android: "Google Play'den alın",
    soon: "Ekran görüntüleri — beta ile birlikte geliyor",
    placeholder: "Ekran görüntüsü yer tutucusu",
  },
  trust: {
    eyebrow: "05 — Güven & Güvenlik",
    title: "Güven için inşa edildi.",
    sub: "Zahmetsiz bir yolculuğun arkasındaki görünmez makine.",
    payments: { t: "Güvenli ödemeler", d: "Her işlemde 3-D Secure ile PCI-DSS uyumlu ödeme altyapısı." },
    verified: { t: "Doğrulanmış sağlayıcılar", d: "Her otel, sürücü ve rehber 27 maddelik denetimden geçer." },
    privacy: { t: "Önce gizlilik", d: "Seyahat programınız sizindir. GDPR uyumlu, asla satılmaz." },
    performance: { t: "Performans", d: "7/24 izlenen %99,95 platform çalışma süresi." },
  },
  form: {
    eyebrow: "Konsiyerj", title: "Yolculuğunuzu başlatın.",
    sub: "Nereye gittiğinizi söyleyin. Bir seyahat tasarımcısı bir iş günü içinde size döner.",
    name: "Ad Soyad", email: "E-posta", destination: "Destinasyon", anywhere: "Her yer / henüz kararsızım",
    message: "Seyahatinizi anlatın", submit: "Talebi gönder", sending: "Gönderiliyor…",
    success: "Alındı — seyahat tasarımcınız kısa süre içinde sizinle iletişime geçecek.", error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
  },
  footer: { tagline: "Dünyayı Güvenle Keşfedin.", contact: "İletişim", privacy: "Gizlilik & UK GDPR", rights: "© 2026 Aurevia Travella. Tüm hakları saklıdır.", langNote: "5 dilde kullanılabilir — yenileri yolda." },
  country: {
    overview: "Genel Bakış", cities: "Şehirler", services: "Mevcut hizmetler",
    cta: "{country} seyahatimi planla",
    intro: "İkonik başkentlerden sessiz kıyılara, {country} meraklı geleni ödüllendirir. Aurevia her kilometresini — otel, transfer, rehber — tek çatı altında düzenler.",
    back: "Tüm destinasyonlar", citiesCount: "{count} şehir",
  },
  city: {
    whyTitle: "Neden gidilmeli",
    highlights: "Öne Çıkanlar", experiences: "Önerilen deneyimler", services: "Mevcut hizmetler",
    guideTitle: "{city} şehrindeki Alpha Guide'ınız",
    guideText: "Havalimanı karşılamadan son dakika rezervasyonlarına — Alpha Guide'ınız {city} şehrini ancak bir yerlinin bilebileceği gibi bilir.",
    gallery: "Galeri", cta: "{city} yolculuğumu planla",
    intro: "{city} meraklıyı ödüllendirir. Aurevia ile {country} ülkesinin ikonları ve gizli köşeleri; bir sürücü, bir rehber ve size göre bükülen bir planla gelir.",
    h1: "İkonik simgeler, mesai sonrası özel erişim", h2: "Sadece yerlilerin bildiği mahalleler", h3: "Kapıdan kapıya günübirlik turlar",
    e1: "Eski şehirde gün doğumu özel turu", e2: "Şef eşliğinde pazar turu ve tadım", e3: "Sıra beklemeden müze öğleden sonrası",
  },
};

const fr = {
  nav: { destinations: "Destinations", services: "Services", guide: "Alpha Guide", app: "L'App", trust: "Confiance", cta: "Commencez votre voyage" },
  cont: { europe: "Europe", "north-america": "Amérique du Nord", "middle-east": "Moyen-Orient", asia: "Asie", oceania: "Océanie", islands: "Îles premium" },
  hero: {
    eyebrow: "Une plateforme de voyage premium et mondiale",
    title1: "Découvrez le monde",
    title2: "en toute confiance.",
    sub: "Hôtels, transferts privés, Alpha Guides locaux et service de conciergerie — une plateforme, tous les continents, zéro friction.",
    cta: "Commencez votre voyage",
    search: "Recherchez un pays, une ville ou un aéroport…",
    statCountries: "Pays", statCities: "Villes", statSupport: "Assistance Alpha Guide", statLangs: "Langues",
  },
  search: { noResults: "Aucun résultat — essayez Paris, Dubaï, CDG…", country: "Pays", city: "Ville", airport: "Aéroport" },
  atlas: { eyebrow: "01 — L'Atlas", title: "Une plateforme. Tous les horizons.", sub: "Choisissez un continent, touchez un pays, et regardez le monde se réorganiser autour de votre voyage.", soon: "Bientôt", explore: "Explorer" },
  services: { eyebrow: "02 — Services", title: "Tout est arrangé.", sub: "Neuf services signature, un seul standard : la perfection." },
  svc: {
    hotels: { t: "Hôtels", d: "Des adresses choisies, des boutiques-hôtels aux suites palaces." },
    transfers: { t: "Transferts aéroport", d: "Arrivées sans couture — votre chauffeur attend avant votre atterrissage." },
    vip: { t: "Transferts VIP", d: "Une mobilité discrète, blindée sur demande, tapis rouge." },
    chauffeur: { t: "Chauffeurs privés", d: "Un professionnel au volant, à l'heure ou à la semaine." },
    guides: { t: "Guides locaux", d: "Des locaux licenciés qui ouvrent des portes qu'aucune appli n'ouvre." },
    tours: { t: "Circuits privés", d: "Des itinéraires pensés pour vous, jamais pour la foule." },
    family: { t: "Voyages en famille", d: "Une logistique pensée pour les enfants, du siège auto aux chambres communicantes." },
    business: { t: "Luxe & Affaires", d: "Du conseil d'administration à la plage, sans friction." },
    medical: { t: "Assistance voyage médical", d: "Cliniques, traducteurs et soins — coordonnés de bout en bout." },
  },
  guide: {
    eyebrow: "03 — Alpha Guide",
    title: "Un humain, où que vous atterrissiez.",
    p1: "Chaque voyage Aurevia inclut un Alpha Guide — un professionnel local agréé, joignable pendant tout votre séjour.",
    p2: "Correspondance manquée, réservation perdue, pharmacie à 3 h du matin — un message et c'est réglé.",
    b1: { t: "Local et vérifié", d: "Des professionnels contrôlés dans chaque ville desservie." },
    b2: { t: "Assistance 24/7", d: "De vraies personnes, dans votre langue, à toute heure." },
    b3: { t: "Attention proactive", d: "Retards, météo, fermetures — nous modifions l'itinéraire avant que vous ne le remarquiez." },
    cta: "Voyagez avec un Alpha Guide",
  },
  app: {
    eyebrow: "04 — L'App",
    title: "Votre voyage, en poche.",
    sub: "Itinéraire en direct, suivi du chauffeur, chat Alpha Guide et reprogrammation en un geste — sur iPhone et Android.",
    ios: "Télécharger dans l'App Store",
    android: "Disponible sur Google Play",
    soon: "Captures d'écran — à venir avec la bêta",
    placeholder: "Emplacement de capture d'écran",
  },
  trust: {
    eyebrow: "05 — Confiance & Sécurité",
    title: "Conçu pour inspirer confiance.",
    sub: "La machinerie invisible derrière un voyage sans effort.",
    payments: { t: "Paiements sécurisés", d: "Traitement conforme PCI-DSS avec 3-D Secure sur chaque transaction." },
    verified: { t: "Prestataires vérifiés", d: "Chaque hôtel, chauffeur et guide passe un audit en 27 points." },
    privacy: { t: "Confidentialité d'abord", d: "Votre itinéraire vous appartient. Conforme au RGPD, jamais vendu." },
    performance: { t: "Performance", d: "99,95 % de disponibilité, surveillée jour et nuit." },
  },
  form: {
    eyebrow: "Conciergerie", title: "Commencez votre voyage.",
    sub: "Dites-nous où vous allez. Un créateur de voyage vous répond sous un jour ouvré.",
    name: "Nom complet", email: "E-mail", destination: "Destination", anywhere: "Partout / je ne sais pas encore",
    message: "Parlez-nous de votre voyage", submit: "Envoyer la demande", sending: "Envoi…",
    success: "Bien reçu — votre créateur de voyage vous contactera très vite.", error: "Une erreur est survenue. Veuillez réessayer.",
  },
  footer: { tagline: "Découvrez le monde en toute confiance.", contact: "Contact", privacy: "Confidentialité & UK GDPR", rights: "© 2026 Aurevia Travella. Tous droits réservés.", langNote: "Disponible en 5 langues — d'autres arrivent." },
  country: {
    overview: "Aperçu", cities: "Villes", services: "Services disponibles",
    cta: "Planifier mon voyage : {country}",
    intro: "Des capitales iconiques aux côtes secrètes, {country} récompense les curieux. Aurevia organise chaque kilomètre — hôtels, transferts, guides — sous un même toit.",
    back: "Toutes les destinations", citiesCount: "{count} villes",
  },
  city: {
    whyTitle: "Pourquoi y aller",
    highlights: "Incontournables", experiences: "Expériences recommandées", services: "Services disponibles",
    guideTitle: "Votre Alpha Guide à {city}",
    guideText: "De la prise en charge à l'aéroport à la table de dernière minute — votre Alpha Guide connaît {city} comme un local.",
    gallery: "Galerie", cta: "Planifier mon voyage à {city}",
    intro: "{city} récompense les curieux. Avec Aurevia, les icônes et les recoins cachés de {country} s'offrent à vous avec chauffeur, guide et un programme qui s'adapte.",
    h1: "Monuments iconiques, accès hors horaires", h2: "Quartiers que seuls les locaux connaissent", h3: "Excursions d'une journée, porte à porte",
    e1: "Visite privée de la vieille ville au lever du soleil", e2: "Marché et dégustation avec un chef", e3: "Après-midi musée coupe-file",
  },
};

const de = {
  nav: { destinations: "Reiseziele", services: "Leistungen", guide: "Alpha Guide", app: "Die App", trust: "Vertrauen", cta: "Reise beginnen" },
  cont: { europe: "Europa", "north-america": "Nordamerika", "middle-east": "Naher Osten", asia: "Asien", oceania: "Ozeanien", islands: "Premium-Inseln" },
  hero: {
    eyebrow: "Eine premium globale Reiseplattform",
    title1: "Entdecken Sie die Welt",
    title2: "mit Zuversicht.",
    sub: "Hotels, private Transfers, lokale Alpha Guides und Concierge-Service — eine Plattform, jeder Kontinent, null Reibung.",
    cta: "Reise beginnen",
    search: "Land, Stadt oder Flughafen suchen…",
    statCountries: "Länder", statCities: "Städte", statSupport: "Alpha-Guide-Support", statLangs: "Sprachen",
  },
  search: { noResults: "Keine Treffer — versuchen Sie Paris, Dubai, CDG…", country: "Land", city: "Stadt", airport: "Flughafen" },
  atlas: { eyebrow: "01 — Der Atlas", title: "Eine Plattform. Jeder Horizont.", sub: "Wählen Sie einen Kontinent, tippen Sie auf ein Land — und sehen Sie, wie sich die Welt um Ihre Reise neu ordnet.", soon: "Bald", explore: "Entdecken" },
  services: { eyebrow: "02 — Leistungen", title: "Alles arrangiert.", sub: "Neun Signature-Services, ein Standard: makellos." },
  svc: {
    hotels: { t: "Hotels", d: "Handverlesene Unterkünfte, vom Boutique-Icon bis zur Palace-Suite." },
    transfers: { t: "Flughafentransfers", d: "Nahtlose Ankunft — Ihr Fahrer wartet, bevor Sie landen." },
    vip: { t: "VIP-Transfers", d: "Diskrete Mobilität, auf Wunsch gepanzert, mit rotem Teppich." },
    chauffeur: { t: "Privatchauffeure", d: "Ein Profi am Steuer — stunden- oder wochenweise." },
    guides: { t: "Lokale Guides", d: "Lizenzierte Locals, die Türen öffnen, die keine App öffnet." },
    tours: { t: "Private Touren", d: "Routen, die um Sie gebaut werden — nie um die Menge." },
    family: { t: "Familienreisen", d: "Kinderfreundliche Logistik, vom Kindersitz bis zu Verbindungszimmern." },
    business: { t: "Luxus & Business", d: "Vom Boardroom an den Strand — ganz ohne Reibung." },
    medical: { t: "Medizinische Reisehilfe", d: "Kliniken, Dolmetscher und Betreuung — durchgehend koordiniert." },
  },
  guide: {
    eyebrow: "03 — Alpha Guide",
    title: "Ein Mensch, wo immer Sie landen.",
    p1: "Jede Aurevia-Reise umfasst einen Alpha Guide — einen geprüften lokalen Profi, der während Ihres gesamten Aufenthalts erreichbar ist.",
    p2: "Verpasster Anschluss, verlorene Reservierung, Apotheke um 3 Uhr nachts — eine Nachricht, und es ist erledigt.",
    b1: { t: "Lokal & geprüft", d: "Verifizierte Profis in jeder Stadt, die wir bedienen." },
    b2: { t: "24/7 Reiseassistenz", d: "Echte Menschen, Ihre Sprache, jederzeit." },
    b3: { t: "Proaktive Fürsorge", d: "Verspätungen, Wetter, Schließungen — wir planen um, bevor Sie es merken." },
    cta: "Reisen Sie mit einem Alpha Guide",
  },
  app: {
    eyebrow: "04 — Die App",
    title: "Ihre Reise in der Tasche.",
    sub: "Live-Reiseplan, Fahrer-Tracking, Alpha-Guide-Chat und Umbuchung per Fingertipp — für iPhone und Android.",
    ios: "Im App Store laden",
    android: "Jetzt bei Google Play",
    soon: "Screenshots — folgen mit der Beta",
    placeholder: "Screenshot-Platzhalter",
  },
  trust: {
    eyebrow: "05 — Vertrauen & Sicherheit",
    title: "Gebaut für Vertrauen.",
    sub: "Die unsichtbare Maschinerie hinter einer mühelosen Reise.",
    payments: { t: "Sichere Zahlungen", d: "PCI-DSS-konforme Abwicklung mit 3-D Secure bei jeder Transaktion." },
    verified: { t: "Verifizierte Anbieter", d: "Jedes Hotel, jeder Fahrer und Guide durchläuft ein 27-Punkte-Audit." },
    privacy: { t: "Datenschutz zuerst", d: "Ihre Reiseroute gehört Ihnen. DSGVO-konform, niemals verkauft." },
    performance: { t: "Performance", d: "99,95 % Plattform-Verfügbarkeit, rund um die Uhr überwacht." },
  },
  form: {
    eyebrow: "Concierge", title: "Beginnen Sie Ihre Reise.",
    sub: "Sagen Sie uns, wohin es geht. Ein Reisedesigner antwortet innerhalb eines Werktages.",
    name: "Vollständiger Name", email: "E-Mail", destination: "Reiseziel", anywhere: "Überall / noch unsicher",
    message: "Erzählen Sie uns von Ihrer Reise", submit: "Anfrage senden", sending: "Wird gesendet…",
    success: "Erhalten — Ihr Reisedesigner meldet sich in Kürze.", error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  },
  footer: { tagline: "Entdecken Sie die Welt mit Zuversicht.", contact: "Kontakt", privacy: "Datenschutz & UK GDPR", rights: "© 2026 Aurevia Travella. Alle Rechte vorbehalten.", langNote: "In 5 Sprachen verfügbar — weitere folgen." },
  country: {
    overview: "Überblick", cities: "Städte", services: "Verfügbare Leistungen",
    cta: "Meine Reise planen: {country}",
    intro: "Von ikonischen Hauptstädten bis zu stillen Küsten belohnt {country} alle, die neugierig ankommen. Aurevia arrangiert jeden Kilometer — Hotels, Transfers, Guides — unter einem Dach.",
    back: "Alle Reiseziele", citiesCount: "{count} Städte",
  },
  city: {
    whyTitle: "Warum hin",
    highlights: "Highlights", experiences: "Empfohlene Erlebnisse", services: "Verfügbare Leistungen",
    guideTitle: "Ihr Alpha Guide in {city}",
    guideText: "Vom Flughafen-Pickup bis zum Last-Minute-Tisch — Ihr Alpha Guide kennt {city} wie nur ein Local.",
    gallery: "Galerie", cta: "Meine {city}-Reise planen",
    intro: "{city} belohnt Neugierige. Mit Aurevia kommen die Ikonen und verborgenen Ecken von {country} mit Fahrer, Guide und einem Plan, der sich nach Ihnen richtet.",
    h1: "Ikonische Wahrzeichen, Zugang nach Feierabend", h2: "Viertel, die nur Locals kennen", h3: "Tagesausflüge von Tür zu Tür",
    e1: "Private Altstadt-Tour bei Sonnenaufgang", e2: "Marktspaziergang & Verkostung mit Koch", e3: "Museum-Nachmittag ohne Warteschlange",
  },
};

const es = {
  nav: { destinations: "Destinos", services: "Servicios", guide: "Alpha Guide", app: "La App", trust: "Confianza", cta: "Comienza tu viaje" },
  cont: { europe: "Europa", "north-america": "Norteamérica", "middle-east": "Oriente Medio", asia: "Asia", oceania: "Oceanía", islands: "Islas premium" },
  hero: {
    eyebrow: "Una plataforma global de viajes premium",
    title1: "Descubre el mundo",
    title2: "con confianza.",
    sub: "Hoteles, traslados privados, Alpha Guides locales y atención de conserjería — una plataforma, todos los continentes, cero fricción.",
    cta: "Comienza tu viaje",
    search: "Busca un país, una ciudad o un aeropuerto…",
    statCountries: "Países", statCities: "Ciudades", statSupport: "Soporte Alpha Guide", statLangs: "Idiomas",
  },
  search: { noResults: "Sin resultados — prueba París, Dubái, CDG…", country: "País", city: "Ciudad", airport: "Aeropuerto" },
  atlas: { eyebrow: "01 — El Atlas", title: "Una plataforma. Cada horizonte.", sub: "Elige un continente, toca un país y mira cómo el mundo se reorganiza alrededor de tu viaje.", soon: "Próximamente", explore: "Explorar" },
  services: { eyebrow: "02 — Servicios", title: "Todo, organizado.", sub: "Nueve servicios insignia, un solo estándar: impecable." },
  svc: {
    hotels: { t: "Hoteles", d: "Estancias seleccionadas, desde boutiques icónicos hasta suites de palacio." },
    transfers: { t: "Traslados al aeropuerto", d: "Llegadas sin fricción: tu chófer espera antes de que aterrices." },
    vip: { t: "Traslados VIP", d: "Movilidad discreta, blindada bajo petición, con alfombra roja." },
    chauffeur: { t: "Chóferes privados", d: "Un profesional al volante, por horas o por semanas." },
    guides: { t: "Guías locales", d: "Locales con licencia que abren puertas que ninguna app abre." },
    tours: { t: "Tours privados", d: "Itinerarios creados en torno a ti, nunca a la multitud." },
    family: { t: "Viajes en familia", d: "Logística a prueba de niños, de la silla de coche a las habitaciones comunicadas." },
    business: { t: "Lujo y negocios", d: "De la sala de juntas a la playa, sin fricciones." },
    medical: { t: "Asistencia de viaje médico", d: "Clínicas, intérpretes y cuidados — coordinados de principio a fin." },
  },
  guide: {
    eyebrow: "03 — Alpha Guide",
    title: "Un humano, aterrices donde aterrices.",
    p1: "Cada viaje Aurevia incluye un Alpha Guide: un profesional local verificado, disponible durante toda tu estancia.",
    p2: "Conexión perdida, reserva extraviada, farmacia a las 3 a. m. — un mensaje y está resuelto.",
    b1: { t: "Local y verificado", d: "Profesionales auditados en cada ciudad donde operamos." },
    b2: { t: "Asistencia 24/7", d: "Personas reales, en tu idioma, a cualquier hora." },
    b3: { t: "Cuidado proactivo", d: "Retrasos, clima, cierres — redirigimos antes de que lo notes." },
    cta: "Viaja con un Alpha Guide",
  },
  app: {
    eyebrow: "04 — La App",
    title: "Tu viaje, en tu bolsillo.",
    sub: "Itinerario en vivo, seguimiento del chófer, chat con tu Alpha Guide y reprogramación con un toque — en iPhone y Android.",
    ios: "Descargar en el App Store",
    android: "Disponible en Google Play",
    soon: "Capturas de pantalla — llegarán con la beta",
    placeholder: "Marcador de captura de pantalla",
  },
  trust: {
    eyebrow: "05 — Confianza y Seguridad",
    title: "Construido para confiar.",
    sub: "La maquinaria invisible detrás de un viaje sin esfuerzo.",
    payments: { t: "Pagos seguros", d: "Procesamiento conforme a PCI-DSS con 3-D Secure en cada transacción." },
    verified: { t: "Proveedores verificados", d: "Cada hotel, chófer y guía supera una auditoría de 27 puntos." },
    privacy: { t: "Privacidad ante todo", d: "Tu itinerario es tuyo. Alineado con el RGPD, nunca vendido." },
    performance: { t: "Rendimiento", d: "99,95 % de disponibilidad, monitorizada día y noche." },
  },
  form: {
    eyebrow: "Conserjería", title: "Comienza tu viaje.",
    sub: "Dinos a dónde te diriges. Un diseñador de viajes responde en un día laborable.",
    name: "Nombre completo", email: "Correo electrónico", destination: "Destino", anywhere: "Cualquiera / aún no lo sé",
    message: "Cuéntanos tu viaje", submit: "Enviar solicitud", sending: "Enviando…",
    success: "Recibido — tu diseñador de viajes te contactará muy pronto.", error: "Algo salió mal. Inténtalo de nuevo.",
  },
  footer: { tagline: "Descubre el mundo con confianza.", contact: "Contacto", privacy: "Privacidad & UK GDPR", rights: "© 2026 Aurevia Travella. Todos los derechos reservados.", langNote: "Disponible en 5 idiomas — más en camino." },
  country: {
    overview: "Resumen", cities: "Ciudades", services: "Servicios disponibles",
    cta: "Planificar mi viaje a {country}",
    intro: "De capitales icónicas a costas tranquilas, {country} recompensa a quien llega con curiosidad. Aurevia organiza cada kilómetro — hoteles, traslados, guías — bajo un mismo techo.",
    back: "Todos los destinos", citiesCount: "{count} ciudades",
  },
  city: {
    whyTitle: "Por qué ir",
    highlights: "Imprescindibles", experiences: "Experiencias recomendadas", services: "Servicios disponibles",
    guideTitle: "Tu Alpha Guide en {city}",
    guideText: "De la recogida en el aeropuerto a la mesa de última hora — tu Alpha Guide conoce {city} como solo un local.",
    gallery: "Galería", cta: "Planificar mi viaje a {city}",
    intro: "{city} recompensa a los curiosos. Con Aurevia, los iconos y los rincones ocultos de {country} llegan con chófer, guía y un plan que se adapta a ti.",
    h1: "Monumentos icónicos, acceso fuera de horario", h2: "Barrios que solo conocen los locales", h3: "Excursiones de un día, puerta a puerta",
    e1: "Tour privado del casco antiguo al amanecer", e2: "Paseo por el mercado con chef y degustación", e3: "Tarde de museos sin colas",
  },
};

export const translations = { en, tr, fr, de, es };
